<template>
  <cham-block animation-class="slideInDown">
    <cham-header main-title="Blog ;" subtitle="Tutorials • News • Reviews • DevLife"/>
    <div>
      <div class="columns is-centered">
        <div class="column is-4">
          <figure class="image is-square">
              <img src="../../assets/technical-support.png">
          </figure>
        </div>
      </div>
      <h2 class="is-6 is-center coming-soon">Coming Soon</h2>
    </div>
  </cham-block>
</template>

<script>
import axios from 'axios';
import 'nprogress/nprogress.css';
import NProgress from 'nprogress'
import Social from '../Social';

export default {
  name : "Blog",
  components : {
    Social
  },
  data () {
    return {
      blogs : [],
      last : 0,
       busy: false
    }
  },
  mounted () {
    document.title = "Blog - Chamara Abeysekara"
    
  },
  methods : {
    setData (post) {
      post.forEach((single) => {
        this.blogs.push(single)
      })
      this.last = post[post.length-1].unixtimestamp
    },
    loadMore (){
      NProgress.start()
      NProgress.set(0.9)
      console.log('asdasd');
    },
    test () {
      return {
           template : '<div>AA aaa <cham-socail/></div>'
        }
    }
  },
  computed: {
    msg () {
        return {
           template : '<div>AA aaa <cham-socail/></div>'
        }
    }
  },
}
</script>

<style lang="scss" >
@import '../../../static/styles.scss';

.coming-soon{
  font-size: 5em;
  margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/componests/pages/Blog.vue